import React from 'react';
import KickImage from 'Reuseables/KickImage';

import { IDateBannerProps } from './DateBanner.definitions';

/** CSS import */
import Styles from './DateBanner.module.scss';

const DateBanner: React.FC<IDateBannerProps> = ({
  date,
  year,
}: IDateBannerProps) => {
  return (
    <div className={Styles['wrapper']}>
      <p className={Styles['text-date']}>
        {date}, {year}
      </p>
    </div>
  );
};

export default DateBanner;
